import { Observable } from 'rxjs';
import { EmpresaAPI } from '@/api/empresa.api';
import { Empresa } from '@/models/empresa';
import { AxiosObservable } from 'axios-observable';

const api = new EmpresaAPI();

const show = (id: number): AxiosObservable<Empresa> => {
  return api.show(id);
}

const create = (company: any): AxiosObservable<Empresa> => {
  return api.create({ company: { ...company } })
}

const update = (id: number, company: any): AxiosObservable<Empresa> => {
  return api.update(id, { company: { ...company } })
}

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const token = (id: number): AxiosObservable<{ token: string }> => {
  return api.token(id);
}

const search = (filters: Record<string, any> = {}): Observable<any> => {
  return api.list({ input: { ...filters }, inputPage: { per_page: 30, sort: 'name:asc' } });
}

export default {
  list,
  search,
  show,
  update,
  create,
  token
}
